import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@/components//ui/checkbox';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { ComponentProps } from 'react';
type ViverseCheckboxProps = {
  containerClassName?: string;
} & ComponentProps<typeof Checkbox>;
function ViverseCheckbox(t0) {
  const $ = _c(19);
  let checked;
  let children;
  let containerClassName;
  let onCheckedChange;
  let props;
  if ($[0] !== t0) {
    ({
      checked,
      onCheckedChange,
      children,
      containerClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = children;
    $[3] = containerClassName;
    $[4] = onCheckedChange;
    $[5] = props;
  } else {
    checked = $[1];
    children = $[2];
    containerClassName = $[3];
    onCheckedChange = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== containerClassName) {
    t1 = cn("flex w-fit items-center py-[10px]", containerClassName);
    $[6] = containerClassName;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== checked || $[9] !== onCheckedChange || $[10] !== props) {
    t2 = <Checkbox id={props.id} checked={checked} onCheckedChange={onCheckedChange} className="data-[state=checked]:text-primary-70 bg-vive-primary-70 text-vive-primary-70 hover:bg-vive-primary-60 data-[state=checked]:bg-primary size-5 cursor-pointer border-none transition-all" {...props} />;
    $[8] = checked;
    $[9] = onCheckedChange;
    $[10] = props;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== children || $[13] !== props.id) {
    t3 = <Label htmlFor={props.id} className="body-1 cursor-pointer pl-4 peer-disabled:cursor-not-allowed peer-disabled:opacity-70">{children}</Label>;
    $[12] = children;
    $[13] = props.id;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}
export default ViverseCheckbox;